import { isValidIBAN, isValidBIC } from 'ibantools'
import moment from 'moment'
import store from '@/store'

export default {
  email: val => (!val || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val)) || 'Ungültige Email',
  number: val => /^[0-9]*$/.test(val, 10) || 'Bitte eine Zahl angeben',
  password: val => (val.length >= 8 && val.length <= 30) || 'Bitte mindestens 8 und maximal 30 Zeichen angeben',
  same_as: (v2) => (v) => v === v2 || 'Werte stimmen nicht überein',
  required: val => !!val || 'Bitte einen Wert angeben',
  required_boolean: val => (val === true || val === false) || 'Bitte einen Wert angeben',
  required_optional: (siblings) => (val) => {
    if (val) {
      return true
    }

    if (siblings.findIndex(s => !!s) >= 0) {
      return true
    }

    return 'Mindestens eines der Felder muss befüllt werden'
  },
  required_oneof: (sibling) => (val) => {
    if (sibling || val) {
      return true
    }
    return 'Bitte einen Wert angeben'
  },
  between: val => (val >= 0 && val <= 10) || 'Bitte einen Wert zwischen 0 und 10 angeben',
  minLen: (n) => (val) => !val || val.length > n || `Bitte geben Sie mindestens ${ n } Zeichen an`,
  maxLen: (n) => (val) => !val || val.length <= n || `Bitte geben Sie weniger als ${ n } Zeichen ein`,
  maxRows: (n) => (val) => !val || val.split(`\n`).length <= n || `Bitte geben Sie weniger als ${ n } Zeilen ein`,
  digits: val => !val || /^[0-9.]+$/.test(val) || 'Bitte eine Zahl angeben',
  integer: val => !val || (!isNaN(parseInt(val)) && val % 1 === 0) || 'Bitte geben Sie eine Ganzzahl ein',
  float: val => !val || (!isNaN(parseFloat(val)) && val % 1 !== 0) || 'Bitte geben Sie eine Float-Nummer ein',
  valid_array: val => val.length > 0 || 'Bitte einen Wert angeben',
  object: val => !val || typeof val === 'object' || 'Bitte einen Wert angeben',
  between_age: (min, max) => (val) => {
    if (!val) {
      return true
    }

    const val_ = moment(val, 'DD.MM.YYYY')
    if (!val_.isValid()) {
      return true
    }

    const val__ = val_.format('YYYY-MM-DD')
    const maxDate = moment().subtract(min, 'years').format('YYYY-MM-DD')
    const minDate = moment().subtract(max, 'years').format('YYYY-MM-DD')

    if (val__ >= minDate && val__ <= maxDate) {
      return true
    }

    return `Bitte einen Datum zwischen ${ minDate } und ${ maxDate } angeben.`
  },
  valid_file_size: (size) => val => !val || (val.size > 0 && val.size <= size * 1024 * 1024) || `Dateigröße sollte kleiner als ${ size } MB sein`,
  valid_date: (format) => (val) => {
    if (!val) {
      return true
    }

    let format_ = format || 'DD.MM.YYYY'

    const val_ = moment(val, format_, true)
    if (val_.isValid()) {
      return true
    }

    format_ = format_.replace('DD', 'TT')
    format_ = format_.replace('YYYY', 'JJJJ')

    return `Das Datumsformat muss ${ format_ } sein.`
  },
  valid_iban: (val) => {
    if (!val) {
      return true
    }

    val = val.replace(/[-\s]/g, '').toUpperCase()
    return isValidIBAN(val) || 'IBAN ist nicht gültig'
  },
  valid_bic: (val) => {
    if (!val) {
      return true
    }

    return isValidBIC(val) || 'BIC ist nicht gültig'
  },
  valid_file: (code) => (val) => {
    if (!val || !store.state.fileError) {
      return true
    }

    if (store.state.fileError.code !== code) {
      return true
    }

    return store.state.fileError.message
  },
  valid_url: (val) => {
    if (!val) {
      return true
    }

    const match = val.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
    return match !== null || 'Bitte geben Sie eine gültige URL ein'
  },
  valid_phone_number: (val) => {
    if (!val) {
      return true
    }

    let regx = /^(?=.*\d)[\d ]+$/
    if (!val.match(regx)) {
      return 'Bitte geben Sie eine gültige Telefonnummer ein'
    }

    regx = /^[1-9][0-9]*/
    return !!val.match(regx) || 'Angabe der Vorwahl ohne der führenden Ziffer Null.'
  },
  valid_regexp: (pattern) => val => {
    if (!val) {
      return true
    }

    const matches = val.match(pattern)
    return (matches !== null && matches[0] === val) || 'Bitte geben Sie einen gültigen Wert ein.'
  },
}
